<template>
    <footer class="py-4 bg-primary">
        <div class="container">
          <div class="d-flex flex-column align-items-center">
            <a href="#">
              <div class="footer-logo mb-4"></div>
            </a>
            <div class="d-md-flex align-items-md-center justify-content-md-center">
              <p class="text-white mb-2 mb-md-0">© 2021 TOB All rights resevered.</p>
              <p class="text-white ms-md-4 text-center">圖片僅供學習使用，無商業用途</p>
            </div>
          </div>
        </div>
    </footer>
</template>
